module.exports = __webpack_public_path__ + "static/img/3ft.060bb88.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/consult/image/3ft.png
// module id = g+m5
// module chunks = 6